define([], function () {
	Date.prototype.addDays = function (days) {
		var date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		return date;
	}

	Date.prototype.toLocaleDate = function (country) {
		var date = new Date(this.valueOf()),
			dd = date.getDate(),
			mm = date.getMonth() + 1;

		switch(country) {
			case 'se':
				return date.getFullYear() + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
			case 'dk':
				return (dd < 10 ? '0' : '') + dd + '-' + (mm < 10 ? '0' : '') + mm + '-' + date.getFullYear();
		}

		return date.getFullYear() + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
	}
});